import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { ComplianceBanner } from "../components/ComplianceBanner";
import { CTASection } from "../components/Sections";

export default function Compliance() {
  const { t } = useTranslation();
  const disclaimers = t("compliance.disclaimers", { returnObjects: true });
  return (
    <>
      <PageHero overline={t("compliance.overline")} title={t("compliance.title")} subtitle={t("compliance.subtitle")} accent="health" testId="compliance-hero" />

      <section className="py-16">
        <div className="container-x max-w-3xl">
          <Reveal>
            <div className="surface p-8"><p className="text-white/70 leading-relaxed">{t("compliance.positioning")}</p></div>
          </Reveal>

          <Reveal>
            <h2 className="mt-12 font-display font-bold text-2xl tracking-tight">{t("compliance.disclaimersTitle")}</h2>
            <ul className="mt-6 space-y-3">
              {disclaimers.map((d, i) => (
                <li key={i} className="flex gap-3 surface p-5" data-testid={`disclaimer-${i}`}>
                  <span className="font-mono text-xs text-gold mt-0.5">0{i + 1}</span>
                  <span className="text-sm text-white/65 leading-relaxed">{d}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal><div className="mt-10"><ComplianceBanner text={t("compliance.banner")} /></div></Reveal>
        </div>
      </section>

      <CTASection title={t("compliance.ctaTitle")} subtitle={t("compliance.ctaSub")} ctaLabel={t("common.contactCta")} ctaTo="/contact" variant="secondary" testId="compliance-cta" />
    </>
  );
}
